"use client";

import { GoogleTagManager, sendGTMEvent } from "@next/third-parties/google";
import { usePathname } from "next/navigation";

import { env } from "~/env.mjs";
import { isTokenPage } from "~/lib/redact-tokens";
import { analytics } from "./AnalyticsProvider";

// lib/gtm.ts
type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[];
};

const GTM_ID = env.NEXT_PUBLIC_GTM_ID;

export default function GTM() {
  // GTM tags read the raw page URL (GA4 page_location), which redaction can't
  // reach, so GTM stays off the pages opened from a bearer link.
  const pathname = usePathname();
  if (isTokenPage(pathname)) return null;
  return (GTM_ID && <GoogleTagManager gtmId={GTM_ID} />) || null;
}

export const trackEvent = (event: string, data: Record<string, any>) => {
  analytics.trackEvent(event, data);
  if (GTM_ID) {
    return sendGTMEvent({ event, data });
  }
};
